import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HandleNumber, GetDoctorUsersByPhone } from "../utils/Api";
import {
  setBasicData,
  setUserData,
  setLoading,
  setOtp,
  setMainUser,
} from "../Redux/Actions/Actions";
import { toast } from "react-toastify";
import { useEffect } from "react";
import Popup from "../components/Popup";

export default function EnterOtp() {
  const Basic = useSelector((state) => state.Basic);
  const [OTP, setSetOTP] = useState("");
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const Dispatch = useDispatch();
  const [profiles, setProfiles] = useState([]);
  const [open, setOpen] = useState(false);

  const ENTIRY_ID = {
    careally: 12,
  };

  useEffect(() => {
    Dispatch(setLoading({ loading: false, otp: false }));
    handleNumber(Basic.code, Basic.number, Basic.redirectFrom);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (OTP === "" && OTP === null)
      return toast.error("Enter OTP to continue!");
    Dispatch(setLoading({ loading: true, otp: false }));
    handleOtpValidation(data);
  };

  const handleNumber = (code, number, redirectFrom) => {
    let entityId = null;
    if (redirectFrom != "" || redirectFrom != null) {
      entityId = ENTIRY_ID[redirectFrom.toLowerCase()];
    }
    HandleNumber({
      mobileCode: code,
      mobileNumber: number,
      NoOTPVerification: 11,
      entityId,
      SourceUrl: redirectFrom,
    }).then((res) => {
      res.json().then((d) => {
        if (d.status == true) {
          setData(d);
        }
      });
    });
    //  const initialProfile = {
    //     userID: MainUser.userID,
    //     type: MainUser.type,
    //     firstName: MainUser.firstName,
    //     Gender: MainUser.Gender,
    //     authToken: MainUser.authToken,
    //     age: "some",
    //   };
  };

  const handleOtpValidation = (d) => {
    if (d.otp == OTP) {
      const { url, existUser } = d;
      if (url) {
        if (existUser == 1) {
          handleProfileByNumber(Basic.code + Basic.number);
        } else {
          if (window.ReactNativeWebView != null) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: "LOGIN_RESPONSE_URL",
                data: d,
              }),
            );
          } else {
            window.open(url, "_blank");
          }
        }
      } else {
        toast.error("Something went wrong, Please try again later.");
      }
    } else {
      setOtp("");
      toast.error("Please enter correct OTP.");
      Dispatch(setLoading({ loading: false, otp: false }));
    }
  };

  const handleProfileByNumber = (number) => {
    GetDoctorUsersByPhone(number).then((res) => {
      if (res.status == true) {
        setProfiles(res.data);
        setOpen(true);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onClose = (profile) => {
    if (window.ReactNativeWebView != null) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "LOGIN_RESPONSE_URL",
          data: profile,
        }),
      );
    } else {
      window.open(profile.url, "_blank");
    }
    setOpen(false);
  };
  const handleResendOtp = async () => {
    Dispatch(setLoading(true));
    handleNumber(Basic.code, Basic.number, Basic.providerCode);
    //depratcated firebase resend otp
    // await onCapthcaVerify(num).then(res=>{
    //   toast.success("OTP resend successfull")
    //   Dispatch(setOtp(res));
    //   Dispatch(setLoading(false))
    // })
  };

  return (
    <div className="flex justify-center items-center text-thtext bg-gray-100">
      <Popup isOpen={open} onClose={onClose} data={profiles} />
      <div className="min-h-screen container items-center ">
        <div className="h-screen flex flex-col justify-start items-center ">
          <div className="max-w-md w-full h-44 bg-otpbg">
            <img
              className=" w-full h-full pt-5"
              src="./assets/otpmessage.svg"
            />
          </div>
          <div className="px-8 pt-6 pb-8 max-w-md w-full h-full font-bold">
            <div className="flex flex-col justify-start items-start">
              <h2 className=" text-lg text-center mb-1">Verify your number</h2>
              <p className="text-sm mb-6">
                OTP sent to {Basic.code + " " + Basic.number}
              </p>
              <p
                onClick={() => {
                  navigate("/");
                }}
                className="text-secondary text-sm mb-6"
              >
                Edit phone number
              </p>
            </div>
            <form
              className="flex flex-col justify-between h-3/4"
              onSubmit={handleSubmit}
            >
              <div className=" flex flex-col">
                <input
                  className="pt-2 focus:outline-none bg-transparent border-b border-gray-300 w-full text-center text-2xl"
                  type="text"
                  placeholder="Enter OTP"
                  value={OTP}
                  maxLength={6}
                  required
                  onChange={(e) => setSetOTP(e.target.value)}
                />
                <div className="flex items-center justify-center mt-4 text-sm">
                  <h4 onClick={handleResendOtp} className="text-secondary">
                    Resend OTP
                  </h4>
                </div>
                <div id="recaptcha-container" className="mt-2"></div>
              </div>

              <button
                className={`bg-primary h-12 text-white font-bold py-2 px-4 mt-6 rounded-full w-full`}
                type="submit"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
